import { Text } from "north.js";
import React, { useState } from "react";
import styled from "styled-components";

import { ChevronDownIcon, ChevronRightIcon } from "src/static/icons";

interface CollapsibleShiftSectionProps {
  title: string;
  count: number;
  defaultOpen?: boolean;
  emptyMessage: string;
  children: React.ReactNode;
}

const CollapsibleShiftSection: React.FC<CollapsibleShiftSectionProps> = ({
  title,
  count,
  defaultOpen = true,
  emptyMessage,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Section>
      <SectionHeader
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        {isOpen ? <ChevronDown /> : <ChevronRight />}
        <Text type="h1">
          {title} ({count})
        </Text>
      </SectionHeader>
      {isOpen &&
        (count === 0 ? (
          <>
            <Spacer />
            <Text>{emptyMessage}</Text>
          </>
        ) : (
          children
        ))}
    </Section>
  );
};

const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SectionHeader = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
`;

const ChevronDown = styled(ChevronDownIcon)`
  width: 20px;
  height: 20px;
  flex: none;
`;

const ChevronRight = styled(ChevronRightIcon)`
  width: 20px;
  height: 20px;
  flex: none;
`;

const Spacer = styled.div`
  height: 24px;
`;

export default CollapsibleShiftSection;
